/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.29.35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Presentation/branding metadata for a game, rendered by clients (e.g. the ticket wallet).
 * @export
 * @interface GameBranding
 */
export interface GameBranding {
    /**
     * Hex colour for text drawn on the brand colour.
     * @type {string}
     * @memberof GameBranding
     */
    fontColorPrimary?: string | null;
    /**
     * Hex colour (e.g. "#0B5394") for the game's primary brand colour.
     * @type {string}
     * @memberof GameBranding
     */
    brandColorPrimary?: string | null;
    /**
     * Hex color (e.g. "#FA7500") for the game's special ball in the ticket wallet. Draw/rapid games only.
     * @type {string}
     * @memberof GameBranding
     */
    specialBallColor?: string | null;
    /**
     * Logo image URL for the game
     * @type {string}
     * @memberof GameBranding
     */
    logoUrl?: string | null;
}

/**
 * Check if a given object implements the GameBranding interface.
 */
export function instanceOfGameBranding(value: object): value is GameBranding {
    return true;
}

export function GameBrandingFromJSON(json: any): GameBranding {
    return GameBrandingFromJSONTyped(json, false);
}

export function GameBrandingFromJSONTyped(json: any, ignoreDiscriminator: boolean): GameBranding {
    if (json == null) {
        return json;
    }
    return {
        
        'fontColorPrimary': json['fontColorPrimary'] == null ? undefined : json['fontColorPrimary'],
        'brandColorPrimary': json['brandColorPrimary'] == null ? undefined : json['brandColorPrimary'],
        'specialBallColor': json['specialBallColor'] == null ? undefined : json['specialBallColor'],
        'logoUrl': json['logoUrl'] == null ? undefined : json['logoUrl'],
    };
}

export function GameBrandingToJSON(value?: GameBranding | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'fontColorPrimary': value['fontColorPrimary'],
        'brandColorPrimary': value['brandColorPrimary'],
        'specialBallColor': value['specialBallColor'],
        'logoUrl': value['logoUrl'],
    };
}

